export interface QuizQuestion {
  id: string;
  category: string;
  question: string;
  options: string[];
  correctAnswer: number; // Index of options (0-3)
  explanation?: string;
}

export enum GameStatus {
  START = 'START',
  CATEGORY_SELECT = 'CATEGORY_SELECT',
  PLAYING = 'PLAYING',
  GAMEOVER = 'GAMEOVER'
}

export interface QuizResult {
  score: number;
  correctCount: number;
  totalCount: number;
  category: string;
  timestamp: number;
}
